const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="color-form green"></div>
      <img src={require("../../assets/img/illu/about.png")} alt="" />
      <aside>
        <h2>A propos</h2>
        <p>
          Innovateur digital passionné, je marie créativité et technologie pour
          transformer chaque projet en une expérience captivante et
          fonctionnelle. Mon parcours diversifié, alliant design graphique et
          développement web, m'inspire à repousser les limites de l'innovation,
          offrant ainsi des solutions sur mesure.{" "}
        </p>
        <div className="social-media">
          <a href="">
            <i class="fa-brands fa-gitlab" style={{ color: "#ffffff" }}></i>
          </a>
          <a href="#contact">
            <i class="fa-solid fa-envelope" style={{ color: "#ffffff" }}></i>
          </a>
          {/* <a href="">
            <i class="fa-brands fa-gitlab" style={{ color: "#ffffff" }}></i>
          </a> */}
        </div>
      </aside>
    </section>
  );
};

export default About;
